<template>
    <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.6095 18.9188L31.7777 11.8122C31.9856 11.6033 32.0556 11.2976 31.9582 11.0221C31.8608 10.7466 31.6132 10.5481 31.3174 10.5092L21.18 9.27294L16.4746 0.41376H16.4743C16.3397 0.159657 16.0716 0.000364932 15.7791 0C15.4801 0.0039201 15.2098 0.174629 15.0837 0.439415L10.7441 9.47714L0.65894 11.1068C0.371192 11.1528 0.132675 11.3488 0.0367527 11.6179C-0.0525994 11.8969 0.0309179 12.2013 0.251201 12.3994L7.70678 19.2301L6.18009 29.1161C6.13742 29.4055 6.2647 29.6938 6.50941 29.8621C6.6407 29.9529 6.79789 30.0014 6.95909 30C7.09075 29.9971 7.21949 29.964 7.33546 29.9027L16.2812 25.0848L25.4152 29.5502C25.6832 29.6795 26.0027 29.6499 26.2412 29.4735C26.4783 29.2989 26.5917 29.007 26.5341 28.7226L24.6095 18.9188Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'IconLabelNew',
};
</script>
